import Workflow from './workflow'
import createRequest from 'airship/modules/request2/ua-request'
import getUrl from 'airship/modules/get-url'
import throwIfNotSuccess from 'airship/modules/request2/utils/throwIfNotSuccess'

const WORKFLOW_USE = 'workflow-use'

const request = createRequest()

export interface WorkflowsResponse {
  workflows: Workflow[]
  limit: number
}

export function refresh(): Promise<WorkflowsResponse> {
  const workflowUse = getWorkflowUse()

  return request
    .get<WorkflowsResponse>({
      pathname: getUrl('apps_workflows', getUrl.APP_KEY),
      redirect: 'error',
    })
    .then(throwIfNotSuccess)
    .then((response) => {
      response.body.workflows = response.body.workflows.sort(
        (workflowA, workflowB) => {
          const lastUsedA = getLastUse(workflowA),
            lastUsedB = getLastUse(workflowB)

          if (lastUsedA === lastUsedB) {
            return 0
          }

          return lastUsedA > lastUsedB ? -1 : 1
        }
      )

      return response.body
    })

  function getLastUse(workflow: Workflow) {
    const lastUsed = workflowUse[workflow.id] || 0

    return lastUsed || new Date(workflow.saved).getTime()
  }
}

export function deleteWorkflow(workflow: Workflow): Promise<any> {
  const url = getUrl('apps_workflow_details', getUrl.APP_KEY, workflow.id)

  return request.delete({pathname: url})
}

export function updateUse(workflowId: string) {
  const counts = getWorkflowUse()

  counts[workflowId] = new Date().getTime()

  window.localStorage.setItem(WORKFLOW_USE, JSON.stringify(counts))
}

function getWorkflowUse(): {[key: string]: number} {
  try {
    return JSON.parse(window.localStorage.getItem(WORKFLOW_USE) || '{}')
  } catch (e) {
    return {}
  }
}
